<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ categoriesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : categoriesData.length }} of {{ categoriesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 ml-3 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-button @click="addNew = true">Add New</vs-button>
          <vs-prompt
            @cancel="cname = ''"
            @accept="add_new_cat"
            @close="close"
            :title="`Add New Category`"
            :active.sync="addNew">
            <div class="con-exemple-prompt">
              <vs-input placeholder="Name" v-model="cname" class="mt-4 mb-2 w-full" />
            </div>
        </vs-prompt>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="categoriesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleCategoryManagement from '@/store/categories-management/moduleCategoryManagement.js'

// Cell Renderer
import CellRendererImage from "./cell-renderer/CellRendererImage.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"



export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererImage,
    CellRendererActions,
  },
  data() {
    return {
      addNew: false,
      searchQuery: "",
      cname: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        // {
        //   headerName: 'Image',
        //   field: 'img',
        //   width: 80,
        //   cellRendererFramework: 'CellRendererImage',
        // },
        {
          headerName: 'Category',
          field: 'name',
          filter: true,
        },
        {
          headerName: 'Last updated',
          field: 'updated_at'
        },
        {
          headerName: 'Actions',
          field: 'id',
          width: 125,
          cellRendererFramework: 'CellRendererActions',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererImage,
        CellRendererActions,
      }
    }
  },
  computed: {
    categoriesData() {
      return this.$store.state.categoryManagement.categories_thematic
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    add_new_cat(){

      let local_data = { name: this.cname }

      this.$store.dispatch("categoryManagement/addNewCategoryThematic" , local_data )
      .then( () => {
          this.$vs.notify({
            color:'success',
            title:'Category added',
            text:'new category added successfuly'
          })

          this.cname = ""

      })
      .catch( err => {

        this.$vs.notify({
          color:'danger',
          title:'Error',
          text: err.response.data.msg
        })
      })
    },
    close(){

    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridApi.sizeColumnsToFit()
  },
  created() {
    if(!moduleCategoryManagement.isRegistered) {
      this.$store.registerModule('categoryManagement', moduleCategoryManagement)
      moduleCategoryManagement.isRegistered = true
    }
    this.$store.dispatch("categoryManagement/fetchCategoriesThematic").catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
